
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_e9lx4_157",
  "disabled": "awsui_disabled_8cbea_e9lx4_237",
  "selected": "awsui_selected_8cbea_e9lx4_245",
  "icon": "awsui_icon_8cbea_e9lx4_266",
  "with-text": "awsui_with-text_8cbea_e9lx4_270",
  "with-no-text": "awsui_with-no-text_8cbea_e9lx4_276",
  "root": "awsui_root_8cbea_e9lx4_281",
  "segment-part": "awsui_segment-part_8cbea_e9lx4_316",
  "select": "awsui_select_8cbea_e9lx4_245",
  "segment-count-2": "awsui_segment-count-2_8cbea_e9lx4_335",
  "segment-count-3": "awsui_segment-count-3_8cbea_e9lx4_339",
  "segment-count-4": "awsui_segment-count-4_8cbea_e9lx4_343",
  "segment-count-5": "awsui_segment-count-5_8cbea_e9lx4_347",
  "segment-count-6": "awsui_segment-count-6_8cbea_e9lx4_351",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_e9lx4_355"
};
  